interface IPageTitleState {
  currentEntityName: string | undefined;
}

export const initialState: IPageTitleState = {
  currentEntityName: undefined,
};
